export class UnionParser {
	static parseText(tex: string) {
		const result: Record<string, string>[] = [];
		let current = "";
		tex.split("\n").forEach((str) => {
			if (/\\[a-z].*/.test(str) || /^\\\\.*/.test(str) || str.includes("$$")) {
				if (str.includes("left[")) {
					current = current ? current + ".[1]" : "[1]";
				} else if (str.includes("left\\{")) {
					current = current ? current + ".{1}" : "{1}";
				}

				if (str.includes("right")) {
					const [outer, inner] = current.split(".");
					if (inner) {
						const arr = outer.split("");
						arr[1] = String(Number(arr[1]) + 1);
						current = arr.join("");
					}
				}
			} else {
				const equation = str.replaceAll("\\", "").trim();
				const [outer, inner] = current.split(".");
				if (inner) {
					result.push({ [outer + inner]: equation });
					const arr = inner.split("");
					arr[1] = String(Number(arr[1]) + 1);
					current = outer + "." + arr.join("");
				} else {
					result.push({ [outer]: equation });
					const arr = outer.split("");
					arr[1] = String(Number(arr[1]) + 1);
					current = arr.join("");
				}
			}
		});
		return result;
	}

	static parseAnswer(config: Record<string, { label: string; path: string }>, answer: Record<string, string>) {
		let result = "";
		let ending = "";
		let current = "";

		Object.entries(config).forEach(([key, value]) => {
			const { path } = value;
			const [outer, inner] = [path.slice(0, 3), path.slice(3, 6)];

			if (inner) {
				if (current === "") {
					result += "$$\n\\left[\n\\begin{matrix}\n\\left\\{\n\\begin{matrix}\n";
					ending += "\\end{matrix}\n\\right.  \n\\end{matrix} \n\\right.\n$$";
					current = outer;
				} else if (current !== outer) {
					result += "\\end{matrix}\n\\right. \n\\\\\n\\left\\{\n\\begin{matrix}\n";
					current = outer;
				}
			} else {
				if (current === "") {
					current = outer;
					result = outer === "[1]" ? "$$\n\\left[\n\\begin{matrix}\n" : "$$\n\\left\\{\n\\begin{matrix}\n";
					ending = "\\end{matrix}\n\\right. \n$$";
				}
			}

			result += `${answer[key].replace(/\$/gi, "")} \\\\\n`;
		});
		result += ending;
		return result;
	}
}
